import request from '@/utils/request'
import { BASE_API } from '@/utils/consts'

// const BASE_API = '/apid'

export function addCustomer(data) {
  return request(`${BASE_API}/customer/create`, {
    method: 'POST',
    data
  })
}

export function updateCustomer(data) {
  return request(`${BASE_API}/customer/update`, {
    method: 'PUT',
    data
  })
}

export function queryCustomers(data) {
  return request(`${BASE_API}/customer/list`, {
    method: 'POST',
    data
  })
}

export function queryFollowCustomers(data) {
  return request(`${BASE_API}/follow-up/customer/follow_list`, {
    method: 'POST',
    data
  })
}

export function queryTabList1(data) {
  return request(`${BASE_API}/follow-up/wait_deal/follow_list`, {
    method: 'POST',
    data
  })
}
export function queryTabList2(data) {
  return request(`${BASE_API}/follow-up/consume_notice/follow_list`, {
    method: 'POST',
    data
  })
}
export function queryTabList3(data) {
  return request(`${BASE_API}/follow-up/renew/follow_list`, {
    method: 'POST',
    data
  })
}
export function queryTabList4(data) {
  return request(`${BASE_API}/follow-up/reservation/follow_list`, {
    method: 'POST',
    data
  })
}
// 关注和隐藏 
export function queryCareHide(data) {
  return request(`${BASE_API}/follow-up/customer/care_hide`, {
    method: 'POST',
    data
  })
}
// 获取客户状态
export function queryCustomerDistribute(data) {
  return request(`${BASE_API}/follow-up/customer_distribute`, {
    method: 'POST',
    data
  })
}

// 获取链接表格
export function queryTableLink(data) {
  return request(`${BASE_API}/customer/statistic`, {
    method: 'POST',
    data
  })
}

export function queryCustomerInfo(data) {
  return request(`${BASE_API}/customer/show/${data.id}`)
}

export function addFollow(data) {
  return request(`${BASE_API}/follow-up/create`, {
    method: 'POST',
    data
  })
}

export function updateFollow(data) {
  return request(`${BASE_API}/follow-up/update`, {
    method: 'PUT',
    data
  })
}

export function addDemand(data) {
  return request(`${BASE_API}/customer-requirement/create`, {
    method: 'POST',
    data
  })
}

export function addReserve(data) {
  return request(`${BASE_API}/reservation/create`, {
    method: 'POST',
    data
  })
}

export function batchAddReserve(data) {
  // return request(`${BASE_API}/reservation/batch/create`, {
  return request(`${BASE_API}/reservation/create`, {
    method: 'POST',
    data
  })
}

export function updateReserve(data) {
  return request(`${BASE_API}/reservation/update`, {
    method: 'PUT',
    data
  })
}

export function queryCustomerFollows(data) {
  return request(`${BASE_API}/follow-up/list`, {
    data
  })
}

export function queryCustomerFollowsDetail(data) {
  return request(`${BASE_API}/follow-up/show/${data.customerId}`)
}

export function queryCustomerDemands(data) {
  return request(`${BASE_API}/customer-requirement/get-by-customer/${data.customerId}`)
}

export function queryCustomerReserves(data) {
  return request(`${BASE_API}/reservation/list_by/${data.customerId}`)
}

export function queryClinicCustomer(data) {
  return request(`${BASE_API}/customer/clinic/list`, {
    method: 'POST',
    data
  })
}

// 客户订单统计
export function queryOrderCount(data) {
  return request(`${BASE_API}/statistics/order/${data.customerId}`)
}

// 客户预约统计
export function queryReserveCount(data) {
  return request(`${BASE_API}/statistics/reservation`, {
    method: 'POST',
    data
  })
}

// 客户消耗统计
export function queryConsumptionCount(data) {
  return request(`${BASE_API}/statistics/consumption`, {
    method: 'POST',
    data
  })
}

// 获取客户的所有执行人列表
export function queryExecutor(data) {
  return request(`${BASE_API}/statistics/list_executor/${data.customerId}`)
}

// 查看客户诊疗档案表单类型列表
export function queryServiceType(data) {
  return request(`${BASE_API}/task/list_service_type/${data.customerId}`)
}

// 查看客户诊疗档案表单类型列表
export function queryCustomerHistory(data) {
  return request(`${BASE_API}/task/list_customer_history`, {
    method: 'POST',
    data
  })
}

// 查看客户诊疗档案表单类型列表  首诊BPS
export function queryBPSCustomerHistory(data) {
  return request(`${BASE_API}/bps/list_history/${data.customerId}`, {
    method: 'GET',
    data
  })
}

//导出
export function exportExcel(data) {
  return request(`${BASE_API}/customer/list/data_export`, { method: 'POST', data, responseType: 'blob', download: true })
}